import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Nav, Events, MenuController, AlertController } from 'ionic-angular';
import { EstudosCientificosPage } from '../estudos-cientificos/estudos-cientificos';
import { SolicitacaoContatoPage } from '../solicitacao-contato/solicitacao-contato';
import { EventosPage } from '../eventos/eventos';
import { ProdutosPage } from '../produtos/produtos';
import { EventoAdversoPage } from '../evento-adverso/evento-adverso';
import { DuvidasSugestoesPage } from '../duvidas-sugestoes/duvidas-sugestoes';
import { UserProvider } from '../../providers/user/user';
import { AtlasPatologiaPage } from '../atlas-patologia/atlas-patologia';
import { environment } from '../../environments/environment.dev';

/**
 * Generated class for the DrawerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-drawer',
  templateUrl: 'drawer.html',
})
export class DrawerPage {

  @ViewChild(Nav) nav: Nav;

  isBrowser = false;
  title
  rootPage

  pages : Array<{ title: string, icon: string, component?: any, showSubmenu?: boolean, submenu?: Array<{ title: string, icon: string, component: any, }> }> = [
    { title: 'Atlas de Patologia', icon: "globe", showSubmenu: false, component: AtlasPatologiaPage },
    { title: 'Estudos científicos', icon: "copy", showSubmenu: false, component: EstudosCientificosPage },
    { title: 'Solicitação de visita', icon: "briefcase", showSubmenu: false, component: SolicitacaoContatoPage },
    { title: 'Eventos', icon: "calendar", showSubmenu: false, component: EventosPage },
    { title: 'Produtos', icon: "flask", showSubmenu: false, component: ProdutosPage },
    //  { title: 'Dados do representante', icon: "globe", showSubmenu: false, component: RepresentantePage },
    {
      title: 'Eventos adversos', icon: "warning", showSubmenu: false, submenu: [
        { title: 'Farmacovigilância', icon: "medical", component: EventoAdversoPage },
        { title: 'Cosmetovigilância', icon: "bulb", component: EventoAdversoPage },
      ]
    },
    { title: 'Dúvidas/Sugestões', icon: "headset", showSubmenu: false, component: DuvidasSugestoesPage }
  ];

  user: any;

  selectedPage: any

  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    public events: Events,
    public userProvider: UserProvider,
    public alertController: AlertController,
    public navParams: NavParams) {

    let param = this.navParams.get("item_selected")

    if (param >= 0) {
      let rootP = this.navParams.get("root_item")
      if (rootP >= 0) {
        this.pages[rootP].showSubmenu = true
        this.selectedPage = this.pages[rootP].submenu[param]
      } else {
        this.selectedPage = this.pages[param]
      }
    } else {
      this.selectedPage = this.pages[0]
    }

    this.configureDrawer()
  }

  ionViewDidLoad() {
    this.openPage(this.selectedPage)
    this.setBrowserOrNot(window.innerWidth)
  }

  ionViewWillEnter() {
    this.events.subscribe('drawer:item_selected', (page) => {
      this.openPage(page);
    });

    this.configureDrawer()
  }

  ionViewWillLeave() {
    this.events.unsubscribe('drawer:item_selected')
  }

  configureDrawer() {
    let userPersisted = this.userProvider.getUserStoraged();

    this.user = {}
    this.user.name = userPersisted.general.data.display_name
    this.user.email = userPersisted.general.data.user_email

    if (userPersisted.acf.foto != undefined) {

      if (userPersisted.acf.foto.indexOf("http") > -1) {
        this.user.photo = userPersisted.acf.foto
      } else {
        this.user.photo = environment.principal_link + userPersisted.acf.foto
      }
    } else {
      this.user.photo = "assets/imgs/avatar-default.png"
    }
  }

  openPage(page) {
    if (page.component != undefined) {

      this.nav.setRoot(page.component, {
        title: page.title,
        isBrowser: this.isBrowser
      })

      this.title = page.title
      this.menu.close();

    } else if (page.icon == "exit") {


    } else {
      page.submenu != undefined

      if (page.showSubmenu == undefined || page.showSubmenu == false)
        page.showSubmenu = true
      else
        page.showSubmenu = false
    }
  }

  onResize(event) {
    this.setBrowserOrNot(event.target.innerWidth)
  }

  setBrowserOrNot(width: number) {
    this.isBrowser = width > 800
    this.menu.enable(!this.isBrowser, "menu");
  }
}




// WEBPACK FOOTER //
// ./src/pages/drawer/drawer.ts